const initialState = {
    isLoggedIn: false,
    showNavigator: true,
    phoneNumber: undefined
}

export function Auth(state = initialState, action) {
  
    switch (action.type) {
        case 'SET_LOGGED_IN':
            return {
                ...state,
                isLoggedIn: action.isLoggedIn
            }
        case 'SET_PHONENUMBER':
            return {
                ...state,
                phoneNumber: action.phoneNumber
            }
        case 'SET_SHOW_NAVIGATOR':
            return {
                ...state,
                showNavigator: action.showNavigator
            }
        case 'SET_INITIAL_AUTH':
            return initialState
        default:
            return state
    }
}